export default {
    SINGLE: 'single'
};
